import { CartLineItemInput } from '@lib/graphql/graphql'
import { CartBundle } from './helpers'
import { VwAddToBasketPayload } from './types'

const skuToVariantIdMap: Record<
  string,
  { productId: string; variantId: string }
> = {
  '10141256': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01jz59jsz6ejr80w4ym9kfs74n',
  },
  '10141258': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01jz59kwm2eqjayc4zxnbb77y4',
  },
  '10141255': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01jzt51c62e0992t94ds90x6jj',
  },
  '10143699': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01jzt5bdrcebrs03551qhnyrpd',
  },
  '10143984': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01jzt5cjxke0jrfb5pkh9kwsj5',
  },
  '10141257': {
    productId: 'product_01jz59fc1neawbq6sdxfg79bev',
    variantId: 'vid_01k56r8sm1e2evzv8nmbxxtbsc',
  },
}

export const mapToCartLineItems: ({
  bundles,
  raw,
}: {
  bundles: CartBundle[]
  raw: VwAddToBasketPayload
}) => Array<CartLineItemInput> = ({ bundles, raw }) => {
  let toAdd: Array<CartLineItemInput> = []

  bundles.forEach((b) => {
    b.lines.forEach((line) => {
      const mapping = skuToVariantIdMap[line.sku]
      if (mapping) {
        toAdd.push({
          variantId: mapping.variantId,
          quantity: line.qty,
          metadata: [
            {
              key: 'vividworks_bundle_id',
              value: b.id,
            },
          ],
        })
      } else {
        console.warn(`No mapping found for SKU: ${line.sku}`)
      }
    })
  })

  return toAdd
}
